@if (open()) {
  <!-- Backdrop -->
  <div
    class="fixed inset-0 bg-dark-bg/60 z-40"
    (click)="onBackdropClick()"
    aria-hidden="true"
  ></div>

  <!-- Drawer panel — role="dialog" gives aria-modal its correct semantic context -->
  <div
    id="mobile-nav-drawer"
    role="dialog"
    aria-modal="true"
    aria-label="{{ 'nav.mobileNavLabel' | transloco }}"
    class="fixed top-0 left-0 h-full w-64 bg-dark-surface border-r border-dark-border z-50 flex flex-col py-6 px-4 gap-2"
    (keydown)="onKeyDown($event)"
  >
    <!-- Close button — visible affordance for keyboard/pointer users -->
    <button
      type="button"
      class="self-end text-dark-text-muted hover:text-dark-text-primary focus:outline-none focus:ring-2 focus:ring-dark-accent rounded p-1 mb-2"
      (click)="onBackdropClick()"
      aria-label="{{ 'common.close' | transloco }}"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5" aria-hidden="true">
        <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
      </svg>
    </button>

    <nav aria-label="{{ 'nav.mainNavLabel' | transloco }}" class="flex flex-col gap-2">
      <!-- Dashboard nav item -->
      <a
        routerLink="/dashboard"
        routerLinkActive="text-dark-accent bg-dark-raised"
        class="flex items-center gap-3 px-3 py-2 rounded-lg text-dark-text-secondary hover:text-dark-text-primary hover:bg-dark-raised transition-colors focus:outline-none focus:ring-2 focus:ring-dark-accent"
        (click)="onNavClick()"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5 shrink-0" aria-hidden="true">
          <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/>
          <rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/>
        </svg>
        <span class="text-sm font-semibold">{{ 'nav.dashboard' | transloco }}</span>
      </a>

      <!-- Roster nav item — coaches only -->
      @if (isCoach()) {
        <a
          routerLink="/roster"
          routerLinkActive="text-dark-accent bg-dark-raised"
          class="flex items-center gap-3 px-3 py-2 rounded-lg text-dark-text-secondary hover:text-dark-text-primary hover:bg-dark-raised transition-colors focus:outline-none focus:ring-2 focus:ring-dark-accent"
          (click)="onNavClick()"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5 shrink-0" aria-hidden="true">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
            <circle cx="9" cy="7" r="4"/>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
          </svg>
          <span class="text-sm font-semibold">{{ 'nav.roster' | transloco }}</span>
        </a>
      }
    </nav>
  </div>
}
